import { Lock } from "lucide-react";
import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import { Button } from "../../client/components/ui/button";
import { useDashboardData } from "./DashboardDataContext";

export default function LockedWidgetCTA() {
  const { t, isDark, onOpenPlanModal } = useDashboardData();
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.lockedWidget.title} isDark={isDark} compact />
      <CardContent className="flex-1 flex flex-col items-center justify-center text-center gap-3 px-4 pb-4 pt-2">
        <div className="rounded-full bg-primary/10 p-3">
          <Lock className="h-6 w-6 text-primary" />
        </div>
        <p className="text-sm font-semibold">{t.dashboard.lockedWidget.title}</p>
        <p className="text-xs text-muted-foreground max-w-[220px]">{t.dashboard.lockedWidget.description}</p>
        <Button size="sm" variant="default" className="text-xs" onClick={() => onOpenPlanModal?.()}>
          {t.dashboard.lockedWidget.cta}
        </Button>
      </CardContent>
    </Card>
  );
}
